<template>
  <v-app>
    <div id="app">
      <v-main>
        <div class="app-header">
          <div class="burger-menu" @click="showLeftMenu = !showLeftMenu"><i class="light-icon-menu-2"></i></div>
          <div class="app-title" @click="$router.push('/')">{{ $vuetify.breakpoint.smAndDown ? 'ENS' : 'Eco-Niwas Samhita' }} Design Aider</div>
          <div class="burger-menu" @click="showRightMenu = !showRightMenu"><i class="light-icon-help"></i></div>
        </div>
        <div class="tr-home-layout">
          <div class="tr-left-col__wrap  " v-if="!$vuetify.breakpoint.smAndDown">
            <LeftCol></LeftCol>
          </div>
          <div class="tr-centre-col__wrap light-scrollbar " :class="{ '--full-width': $vuetify.breakpoint.smAndDown }">
            <div class="tr-centre-col light-scrollbar scrollable">
              <router-view />
            </div>
          </div>
          <div class="tr-right-col__wrap light-scrollbar scrollable" v-if="!$vuetify.breakpoint.smAndDown">
            <RightCol></RightCol>
          </div>
        </div>
      </v-main>
      <v-navigation-drawer v-model="showLeftMenu" fixed app temporary width="300px" v-if="$vuetify.breakpoint.smAndDown">
        <LeftCol></LeftCol>
      </v-navigation-drawer>
      <v-navigation-drawer v-model="showRightMenu" fixed app temporary right width="300px" v-if="$vuetify.breakpoint.smAndDown">
        <RightCol></RightCol>
      </v-navigation-drawer>
    </div>
  </v-app>
</template>

<script>
import LeftCol from '@/components/layout/LeftCol.vue';
import RightCol from '@/components/layout/RightCol.vue';
import '@/utils/smooth-scroll.scss';

export default {
  name: 'App',
  components: {
    LeftCol,
    RightCol,
  },
  data: () => ({
    //
    showLeftMenu: false,
    showRightMenu: false,
  }),
  watch: {
    projects: {
      handler: function(allProjects) {
        localStorage.setItem('projects', JSON.stringify(allProjects));
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    projects: {
      get: function() {
        return this.$store.state.projects;
      },
      set: function(newProjects) {
        this.$store.dispatch('setProjects', newProjects);
      },
    },
  },
};
</script>
<style lang="scss">
@import '~light-icons/dist/light-icon.css';
[class^='light-icon-'],
[class*=' light-icon-'] {
  vertical-align: inherit !important;
}
/* Extra small devices (phones, 600px and down) */
// @media only screen and (max-width: 600px) {
//   .tr-left-col__wrap,
//   .tr-right-col__wrap {
//     display: none;
//   }
// }
body {
  margin: 0;
  padding: 0;
}
@import '@/utils/smooth-scroll.scss';
.tr-home-layout {
  display: flex;
  width: 100vw;
  // height: 100%;
}
.app-header {
  // width: 100%;
  // position: fixed;
  // background-color: #5a6978;
  // text-align: center;
  // padding: 12px 24px;
  // color: #fff;
  // font-size: 24px;
  // font-weight: 400;
  // ------
  display: flex;
  align-items: center;
  // justify-content: center;
  justify-content: space-between;
  align-items: stretch;

  background-color: #203d4a;
  color: #ffffff;
  padding: 8px 24px;

  position: fixed;
  top: 0px;
  width: 100%;
  z-index: 100;
}
.app-title {
  font-size: 20px;
  // padding: 16px;
  cursor: pointer;
  // line-height: 24px;
  text-transform: uppercase;
  margin-left: 12px;
}
.burger-menu {
  cursor: pointer;

  i {
    font-size: 20px;
    font-weight: 500;
    color: #ffffff;
  }
}
.tr-left-col__wrap,
.tr-right-col__wrap {
  width: 300px;
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  height: 100%;
  background-color: #5a6978;
}

.tr-centre-col__wrap {
  // width: 60%;
  display: flex;
  flex-grow: 1;
  flex-direction: column;

  height: 100vh;
  max-width: calc(100% - 600px);
  background-color: #e9f2fa;
  &.--full-width {
    max-width: 100%;
  }
}
.scrollable {
  height: 100%;
  overflow: auto; // here is the magic :)
}
.tr-centre-col {
  display: flex;
  flex-direction: column;
  // justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
}
</style>
